export default "__VITE_ASSET__Cb8Bb$je__"